module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-left-3.1afc2c1a.png";